export default {
    home: {
        icon1:'Stable and agile',
        icon2:'Stable and light shaft transmission, stable and agile',
        icon3:'Energy saving and efficient',
        icon4:'75% more energy-efficient than clutch motors',
        icon5:'Strong compatibility',
        icon6:'The same electronic control can be compatible with multiple models of electric and pneumatic vehicles',
        icon7:'Mechatronics integration',
        icon8:'Unique characteristic craftsmanship',
        icon9:'Fault emergency stop',
        icon10:'Ensure damage to components during the sewing process'
    },
    footer: {
        name:'Copyright',
        phone: 'phone',
        time: 'email',
        address: 'address',
        copyright: 'ICP filing',
        phoneContent: '0576-88177577',
        timeContent: 'weekday 9：00-18：00',
        addressContent: 'Xiachen Liuyang Industrial Zone, Jiaojiang District, Taizhou City',
        copyrightContent: 'Zhejiang Baihui Sewing Machine Corporation  浙ICP备15035833号-1  Public security filing number3310020200001',
        contact:'Contact Us',
        mobile:'mobile phone',
    },
    index: {
        about: 'About Us',
        about1: 'Zhejiang Parfit Sewing Machine Co., Ltd. is a professional factory located in the research and development and production of high-end special decorative sewing machines, known for producing small batches, multiple varieties, and high quality.',
        about2: " At the same time, continuous research and development, increased investment in high-end equipment, and introduced the world-renowned equipment manufacturer “MORI SEIKI” brand's horizontal machining centers, vertical machining centers, and turning milling composite machining centers. KITA MVR precision lathe and BROTHER drilling center, KENT grinding machine. To ensure the precision of machine casing processing and components, we have developed a series of highly advanced international curved tooth machines, including the small circle embroidery and threading machine series, as well as the four needle and six thread stitching series products.",
        about3: 'The company adheres to the core concept of "specialization, refinement, and strength", based on the most dynamic model in the sewing machine industry - the multi needle machine, and has become the production enterprise with the most varieties, the best quality, and the largest production and sales volume.',
        look: 'See more',


        product1: 'A professional factory known for producing small batches, multiple varieties, and high quality of high-end special decorative sewing machines through research and development and production',
        product2: 'Bag sticking machine',
        cowboy1: 'A professional factory known for producing small batches, multiple varieties, and high quality of high-end special decorative sewing machines through research and development and production',
        load:'Color page download',

        companyProfile:"company profile",
        companyProfileText:"The American needle industrial sewing machine originates from the fine work of German quality.The American needle industrial sewing machine relies on the absolute leading edge of China's zhejiang province in the sewing equipment industry.With the integration of r&d, production and sales, and after-sales guarantee, it has become a pioneer and leader in the international sewing equipment industry.The company is located in yiwu, zhejiang, a small commodity city in China, with superior geographical position and convenient transportation.The company manages the import, the domestic complete set of sewing equipment, the sale and the acquisition of all kinds of import, domestic new and old sewing equipment.General agent of zhejiang province: SINGER of the United States, general agent of zhejiang and China: DADILI of Japan, general agent of jiangnan: WANPING, JINJIAN, BAOGE, BROTHER, LIAMATO, SENBEN, JUKI, YAMATO, PEGASUS, gemus, etc.",
        companyHonors:"Company Honors",
        companyHonorsText1:"Yiwu Sewing Machinery Technology Industry Association",
        companyHonorsText2:"Our company was awarded as a unit by the China Sewing Equipment Industry Association and the Commerce Commission in 2021.",

    },
    message:{
        title:'title',
        contacts:"contacts",
        phone:'phone',
        email:'email',
        corporateName:'Corporate name',
        corporateAddress:'Company address',
        content:'content',
        submit:'submit',
        mes:'Hello, welcome to our customer service center. Please fill in your questions in detail here, and leave your accurate Email address and other contact information. Our staff will reply to you as soon as possible within 24 hours.',
        placeholder1:'Please enter a title',
        placeholder2:'Please enter your name',
        placeholder3:'Please enter your phone number',
        placeholder4:'Please enter your email address',
        placeholder5:'Please enter your company name',
        placeholder6:'Please enter your company address',
        placeholder7:'Please enter',
        leave:'leave'
    },
    service:{
        before:'Pre-Sales Technical Support',
        beforeTitle:'Personalized product customization, networked collaborative development, and information-based data processing',
        nows:'Sales line tracking',
        nowsTitle:'Standardized process control, specialized installation guidance, dynamic quality tracking',
        after:'After sales quick repair service',
        afterTitle:'Community service model, online shopping service experience, and regular service training'
    },
    product:{
        title1:'energy saving',
        mes1:'Comparable clutch motor saves 75% electricity',
        title2:'Through shaft transmission',
        mes2:'Stable and agile, reducing the overall torque and ensuring stable operation',
        title3:'Vibration noise',
        mes3:'Low noise, less prone to fatigue, and improved work efficiency',
    },
    about:{
        describe1:'Continuous investment in research and development funds, accounting for 5% -8% of total sales revenue annually',
        describe2:'Authorized Patent',
        describe3:'company staff',
        describe4:'Factory building area'
    }
}
